<template slot="main">
  <el-dialog
    :visible.sync="open"
    :before-close="close">
    <div>
      <h2 class="text-xl mb-1">Total views by steps</h2>
      <div class="bg-white rounded shadow p-8">
        <div class="mb-2">
          <div class="mt-2">
            <canvas id="graph2"></canvas>
            <div class="clr-lbl">
              <div class="bx gr1"></div>
              <p class="bx-lbl">Number of last button clicked</p>
            </div>
            <div class="clr-lbl">
              <div class="bx gr2"></div>
              <p class="bx-lbl">Number of unique last button clicked</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Chart, BarController, CategoryScale, LinearScale } from 'chart.js';

export default {
  name: 'WaveStats2',

  props: {
    open: {
      type: Boolean,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loaded: false,
      chart: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('waves', {
      getById: 'getById',
      waves: 'waves'
    }),

    wave () {
      return this.getById(this.id)
    }
  },

  methods: {
    ...mapActions('waves', ['loadWave', 'getStepStats']),
    initWave2 () {
      Chart.register(BarController, CategoryScale, LinearScale);

      this.loadWave({id: this.id}).then((wave) => {
        this.getStepStats({id: this.id}).then((data) => {
          // Chart 2
          console.log(Object.entries(data.results.steps).map(result => result[1].views.total))
          var totalViews = Object.entries(data.results.steps).map(result => result[1].views.total);
          var uniqueViews = Object.entries(data.results.steps).map(result => result[1].views.unique);
          const views = [totalViews, uniqueViews]
          const barColors = ['rgb(255, 99, 132, 0.5)', 'rgb(54, 162, 235, 0.5)'];
          const doneColors = ['rgb(0, 150, 0, 0.5)', 'rgb(80, 200, 80, 0.5)'];

          var backgroundColors = [];
          var borderColors = [];

          barColors.forEach((barColor, idx) => {
            var colors = [];
            for (let index = 0; index < views[idx].length; index++) {
              colors.push(barColor)
            }
            colors.push(doneColors[idx])

            backgroundColors.push(colors);
            borderColors.push(colors);
          });

          totalViews.push(data.results.finish.total);
          uniqueViews.push(data.results.finish.unique);
          var horizontalBarChartData = {
            labels: this.getLabels(data.results.steps.length),
            datasets: [{
              label: 'Number of views',
              backgroundColor: backgroundColors[0],
              borderColor: borderColors[0],
              data: views[0]
            }, {
              label: 'Unique views numbers',
              backgroundColor: backgroundColors[1],
              borderColor: borderColors[1],
              data: views[1]
            }]
          }

          const ctx2 = document.getElementById('graph2')
          if (ctx2) {
            let parameters = {
              type: 'bar',
              data: horizontalBarChartData,
              options: {
                indexAxis: 'y',
                elements: {
                  rectangle: {
                    borderWidth: 2
                  }
                },
                responsive: true,
                legend: {
                  position: 'bottom'
                },
                title: {
                  display: false
                },
                scales: {
                  x: {
                    beginAtZero: true
                  }
                },
              }
            }
            if (horizontalBarChartData.labels.length === 0) {
              parameters.options['tooltips'] = {
                callbacks: {
                  title: function () {}
                }
              }
            }
            this.chart = new Chart(ctx2, parameters)
          }
        })
      })
    },

    getLabels (numberOfSteps) {
      var labels = []
      if (numberOfSteps <= 1) {
        labels.push('Wave views')
        labels.push('Last button clicked')
        return labels
      }
      for (let i = 0; i < numberOfSteps; ++i) {
        if (i + 1 === numberOfSteps) {
          labels.push('Final Step')
        } else {
          labels.push('Step ' + (i + 1))
        }
      }
      labels.push('Last button clicked')
      return labels
    }
  },

  mounted () {
    this.initWave2()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/waves/ui/modal/stats.vue